import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			main: "#E64A19",
		},
		secondary: {
			main: "#FFD54F",
		},
		success: {
			main: "#4CAF50",
		},
		background: {
			default: "#FFF3E0",
		},
	},
	typography: {
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		h2: {
			fontWeight: 700,
		},
		h5: {
			fontWeight: 500,
		},
		h6: {
			fontWeight: 600,
		},
	},
	// breakpoints: {
	// 	values: {
	// 		xs: 0,
	// 		sm: 600,
	// 		md: 960,
	// 		lg: 1280,
	// 		xl: 1920,
	// 	},
	// },
	breakpoints: {
		values: {
		  xs: 0,
		  sm: 600,
		  md: 960,
		  lg: 1200,
		  xl: 1536,
		  xxl: 1920, 
		},
	  },
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 4,
					textTransform: "none",
					fontFamily: "Roboto Condensed",
					fontWeight: 500,
					fontSize: "18px",
					lineHeight: "100%",
					letterSpacing: "0%",
				},
			},
		},
		// MuiCard: {
		// 	styleOverrides: {
		// 		root: {
		// 			borderRadius: 8,
		// 			margin: {
		// 				xs: "8px",
		// 				sm: "16px",
		// 				md: "24px",
		// 			},
		// 			padding: {
		// 				xs: "16px",
		// 				// sm: "24px",
		// 				md: "32px",
		// 			},
		// 		},
		// 	},
		// },
		MuiCard: {
			styleOverrides: {
				root: {
					borderRadius: 8,
					margin: {
						xs: "8px",
						sm: "16px",
						md: "24px",
						xxl: "32px", 
					},
					padding: {
						xs: "16px",
						md: "32px",
						xxl: "48px", 
					},
				},
			},
		},
		
		MuiContainer: {
			styleOverrides: {
			  root: {
				paddingLeft: "0px",
				paddingRight: "0px",
				[`@media (min-width:600px)`]: {
				  paddingLeft: "0px",
				  paddingRight: "0px",
				},
				[`@media (min-width:900px)`]: {
				  paddingLeft: "0px",
				  paddingRight: "0px",
				},
				[`@media (min-width:1200px)`]: {
				  paddingLeft: "0px",
				  paddingRight: "0px",
				},
				[`@media (min-width:1536px)`]: {
				  paddingLeft: "0px",
				  paddingRight: "0px",
				},
				[`@media (min-width:1920px)`]: {
					paddingLeft: "0px",
					paddingRight: "0px",
				},
				
			  },
			},
		  },
		  
		MuiTypography: {
			styleOverrides: {
				root: {
					fontSize: {
						xs: "14px",
						sm: "16px",
						md: "18px",
					},
					lineHeight: 1.5,
				},
				h1: {
					fontSize: {
						xs: "24px",
						sm: "32px",
						md: "48px",
					},
				},
				h2: {
					fontSize: {
						xs: "20px",
						sm: "28px",
						md: "36px",
					},
				},
			},
		},
	},
});

export default theme;
